module.exports = __webpack_public_path__ + "static/media/square-quarters.ee3a51af.svg";